<template>
  <v-container>
    <p
      v-if="this.$route.query.tour_code"
      class="text-h5"
    >
      Edit Tour
    </p>
    <p
      v-else
      class="text-h5"
    >
      Create New Tour {{ information_tour.tour_code }}
    </p>
    <v-stepper v-model="e1">
      <v-stepper-header>
        <v-stepper-step
          :complete="e1 > 1"
          step="1"
        >
          Information Tour
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="e1 > 2"
          step="2"
        >
          Travel Cost
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step
          :complete="e1 > 3"
          step="3"
        >
          Hotel
        </v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step step="4">
          Itinerary
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <!------------------------CONTENT---------------------->

        <v-stepper-content step="1">
          <v-card
            class="mb-12"
            color="grey lighten-1"
          >
            <StepOne ref="StepOne"></StepOne>
          </v-card>

          <v-btn
            color="primary"
            @click="getStepOne()"
          >
            Continue
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card
            class="mb-12"
            color="grey lighten-1"
          >
            <StepTwo
              ref="StepTwo"
              :datainvoice="information_tour"
            ></StepTwo>
          </v-card>

          <v-btn
            color="primary"
            @click="getStepTwo()"
          >
            Continue
          </v-btn>
          <v-btn
            text
            @click="e1 = 1"
          >
            Back
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="3">
          <v-card
            color="grey lighten-1"
          ></v-card>
          <StepThree
            ref="StepThree"
            :datainvoice="information_tour"
          ></StepThree>
          <v-btn
            color="primary"
            @click="getStepThree()"
          >
            Continue
          </v-btn>

          <v-btn
            text
            @click="e1 = 2"
          >
            Back
          </v-btn>
        </v-stepper-content>

        <v-stepper-content step="4">
          <v-card
            color="grey lighten-1"
          >
            <StepFour
              ref="StepFour"
              :datainvoice="information_tour"
            ></StepFour>
          </v-card>
          <v-btn
            color="primary"
            @click="SaveData()"
          >
            Save New Tour
          </v-btn>

          <v-btn
            text
            @click="e1 = 3"
          >
            Back
          </v-btn>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>

    <v-row
      class="font-weigth-bold mt-3"
    >
      <v-col></v-col>
      <v-col>
        <v-simple-table>
          <thead>
            <tr>
              <td>New Markup</td>
              <td>
                <v-currency-field
                  v-model="information_tour.newmarkup"
                  prefix="Rp."
                  type="number"
                  dense
                  hide-details=""
                  outlined
                  placeholder="New Markup"
                  label="New Markup"
                  @change="CountGrandTotal()"
                />
              </td>
            </tr>
            <tr class="font-weight-bold text-h6  ">
              <td>
                <span class=" text-h6 "> Total Perpax Adult </span>
              </td>
              <td>
                <span class=" text-h6 ">: Rp. {{ Number(information_tour.total_perpax_adult).toLocaleString() }}</span>
              </td>
            </tr>
            <tr
              v-if="information_tour.total_cnb > 0"
              class="font-weight-bold text-h6  "
            >
              <td>
                <span class="  text-h6 ">Total Perpax CNB </span>
              </td>
              <td>
                <span class=" text-h6 ">: Rp. {{ Number(information_tour.total_perpax_cnb).toLocaleString() }}</span>
              </td>
            </tr>
            <tr
              v-if="information_tour.total_cwb > 0"
              class="font-weight-bold text-h6  "
            >
              <td>
                <span class=" text-h6 ">Total Perpax CWB </span>
              </td>
              <td>
                <span class=" text-h6 ">: Rp. {{ Number(information_tour.total_perpax_cwb).toLocaleString() }}</span>
              </td>
            </tr>
            <tr class="font-weight-bold text-h6 bg-gradient-primary ">
              <td>
                <span class="  text-h6 ">Total Per pax</span>
              </td>
              <td>
                <span class=" text-h6 ">: Rp. {{ Number(information_tour.grandtotal).toLocaleString() }}</span>
              </td>
            </tr>
          </thead>
        </v-simple-table>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import axios from 'axios'

import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiContentSave,
} from '@mdi/js'
import StepOne from '@/layouts/components/blm/StepOne.vue'
import StepTwo from '@/layouts/components/blm/StepTwo.vue'
import StepThree from '@/layouts/components/blm/StepThree.vue'
import StepFour from '@/layouts/components/blm/StepFour.vue'

export default {
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepFour,
  },
  data() {
    return {
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiContentSave,
      },
      e1: 1,
      information_tour: {
        note: '',
        region: '',
        id_tour: '',
        tour_code: '',
        newmarkup: 0,
        exchange_rate: 0,
        total_perpax_adult: 0,
        total_perpax_cnb: 0,
        total_perpax_cwb: 0,
        grandtotal: 0,
        guest_name: '',
        travel_date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        total_day: 0,
        end_travel_date: '',
        total_pax: 0,
        total_adult: 1,
        total_cwb: 0,
        total_cnb: 0,
        file_handler: '',
        agent_name: '',
        agent_code: '',
        id_agent: '',
        phone: '',
        email: '',
        travel_cost: {
          record_guide: {
            id_guide: '',
            description: '-',
            cost: 0,
            duration: 1,
            total: 0,
            per_pax: 0,
          },
          fixcost: 0,
          varcost: 0,
          detailvarcost: [],
          detailfixcost: [],
        },
        hotels: [],
      },
      itinerari: [],
    }
  },
  mounted() {
    this.$root.$on('CountPerpax', () => {
      if (this.$refs.StepTwo.$data) {
        const Data2 = this.$refs.StepTwo.$data
        this.information_tour.travel_cost = Data2.travelcost
      }

      if (this.$refs.StepThree.$data) {
        const Data3 = this.$refs.StepThree.$data
        this.information_tour.hotels = Data3.datahotel
      }
      if (this.$refs.StepFour.$data) {
        const Data = this.$refs.StepFour.$data
        this.itinerari = Data.itinerary
      }

      this.CountGrandTotal()
    })
  },
  methods: {
    SaveData() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveNewTour', this.information_tour).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.isLoading = false
        this.SimpanItinerary(response.data.data.id_tour)
      }).catch(err => {
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },
    SimpanItinerary(idtour) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveItinerary', { idtour, data: this.itinerari }).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.isLoading = false
        this.$router.replace({ path: 'ItinerariData' })
      }).catch(err => {
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
        this.isLoading = false
      })
    },
    getStepOne() {
      const Data = this.$refs.StepOne.$data
      this.information_tour = Data.forminvoice
      this.$store.commit('setDataItinerari', this.information_tour)
      this.information_tour.travel_cost = {
        record_guide: {
          id_guide: '',
          description: '-',
          cost: 0,
          duration: 1,
          total: 0,
          per_pax: 0,
        },
        fixcost: 0,
        varcost: 0,
        detailvarcost: [],
        detailfixcost: [],
      }
      if (this.information_tour.total_adult === 0) {
        this.$root.$emit('PesanResponse', 'Please enter the number of adults', 'red')
      } else if (this.information_tour.total_day === 0) {
        this.$root.$emit('PesanResponse', 'Please enter the number of days', 'red')
      } else {
        this.$refs.StepTwo.Update()
        this.e1 = 2
      }
    },
    getStepTwo() {
      const Data = this.$refs.StepTwo.$data
      this.$refs.StepThree.UpdateQty()
      this.information_tour.travel_cost = Data.travelcost
      this.e1 = 3
      this.CountGrandTotal()
    },
    getStepThree() {
      const Data = this.$refs.StepThree.$data
      this.$refs.StepFour.UpdateData()
      this.information_tour.hotels = Data.datahotel
      this.e1 = 4
      this.CountGrandTotal()
    },
    CountGrandTotal() {
    // eslint-disable-next-line no-alert
      let perpaxadult = 0
      let perpaxchild = 0
      let perpaxcnb = 0
      let perpaxcwb = 0

      if (this.itinerari.data) {
        this.itinerari.data.forEach(number => {
          let grandtotaladult = 0
          let grandtotalchild = 0
          let grandtotalcnb = 0
          let grandtotalcwb = 0
          number.details.forEach(data => {
            if (data.category === 'Transport') {
              // eslint-disable-next-line no-const-assign, radix
              grandtotaladult += parseInt(data.perpax_adult)
            } else if (data.category === 'Hotel') {
              // eslint-disable-next-line no-const-assign, radix
              grandtotaladult += parseInt(data.perpax_room_only)
              // eslint-disable-next-line no-const-assign, radix
              grandtotalcnb += parseInt(data.perpax_cnb)
              // eslint-disable-next-line no-const-assign, radix
              grandtotalcwb += parseInt(data.perpax_cwb)
            } else {
              // eslint-disable-next-line no-const-assign, radix
              grandtotaladult += parseInt(data.perpax_adult)
              // eslint-disable-next-line no-const-assign, radix
              grandtotalchild += parseInt(data.perpax_child)
            }
          })

          perpaxadult += grandtotaladult
          perpaxchild += grandtotalchild
          perpaxcnb += grandtotalcnb
          perpaxcwb += grandtotalcwb
        })
      }

      let perpaxadulthotel = 0
      let perpaxcnbhotel = 0
      let perpaxcwbhotel = 0

      if (this.information_tour.hotels) {
        this.information_tour.hotels.forEach(number => {
          // eslint-disable-next-line no-const-assign
          perpaxadulthotel += number.perpax_room_only
          // eslint-disable-next-line no-const-assign
          perpaxcnbhotel += number.perpax_cnb
          // eslint-disable-next-line no-const-assign
          perpaxcwbhotel += number.perpax_cwb
        })
      }

      // eslint-disable-next-line radix
      const { newmarkup } = this.information_tour
      // eslint-disable-next-line radix
      if (parseInt(this.information_tour.total_adult) > 0) {
      // eslint-disable-next-line radix
        let guidepax = 0
        // eslint-disable-next-line radix
        if (parseInt(this.information_tour.travel_cost.record_guide.per_pax) > 0) {
          // eslint-disable-next-line no-const-assign
          guidepax += this.information_tour.travel_cost.record_guide.per_pax
        } else {
          // eslint-disable-next-line no-const-assign
          guidepax += 0
        }
        // eslint-disable-next-line radix
        this.information_tour.total_perpax_adult = parseInt(perpaxadulthotel) + parseInt(guidepax) + parseInt(this.information_tour.travel_cost.varcost) + parseInt(this.information_tour.travel_cost.fixcost) + parseInt(perpaxadult) + parseInt(newmarkup)
      } else {
        this.information_tour.total_perpax_adult = 0
      }

      // eslint-disable-next-line radix
      if (parseInt(this.information_tour.total_cnb) > 0) {
        // eslint-disable-next-line radix
        this.information_tour.total_perpax_cnb = parseInt(perpaxcnbhotel) + parseInt(this.information_tour.travel_cost.fixcost) + parseInt(perpaxchild) + parseInt(perpaxcnb) + parseInt(newmarkup)
      } else {
        this.information_tour.total_perpax_cnb = 0
      }
      // eslint-disable-next-line radix
      if (parseInt(this.information_tour.total_cwb) > 0) {
      // eslint-disable-next-line radix
        this.information_tour.total_perpax_cwb = parseInt(perpaxcwbhotel) + parseInt(this.information_tour.travel_cost.fixcost) + parseInt(perpaxchild) + parseInt(perpaxcwb) + parseInt(newmarkup)
      } else {
        this.information_tour.total_perpax_cwb = 0
      }
      // eslint-disable-next-line radix
      this.information_tour.grandtotal = (parseInt(this.information_tour.total_perpax_adult) + parseInt(this.information_tour.total_perpax_cnb)) + parseInt(this.information_tour.total_perpax_cwb)
    },
  },
}
</script>
